<template>
  <div class="editor" style="">
    <Toolbar class="tool" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor class="text" :defaultConfig="editorConfig" v-model="html" @onChange="onChange" @onCreated="onCreated" />
  </div>
</template>

<script>
/* eslint-disable */
import { Editor, Toolbar } from "@wangeditor/editor-for-vue"
import authApi from "@/api/auth"
export default {
  name: "MyEditor",
  components: { Editor, Toolbar },
  props: {
    id: {
      type: String,
      default: "editor",
    },
    value: String,
  },
  data() {
    return {
      editor: null,
      html: "",
      toolbarConfig: {
        toolbarKeys: [// [ /* 显示哪些菜单，如何排序、分组 */ ]
          "headerSelect",
          "blockquote",
          "header1",
          "header2",
          "header3",
          "|",
          "bold",
          "underline",
          "italic",
          "through",
          "color",
          "bgColor",
          "clearStyle",
          "|",
          "fontSize",
          "fontFamily",
          "lineHeight",
          "|",
          "bulletedList",
          "numberedList",
          // "todo",
          "justifyLeft",
          "justifyRight",
          "justifyCenter",
          "divider",
          {
            iconSvg: "<svg viewBox=\"0 0 1024 1024\"><path d=\"M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z\"></path></svg>",
            key: "group-indent",
            menuKeys: ["indent", "delIndent"]
          },
          "|",
          "insertLink",
          "emotion",
          {
            key: 'group-image',
            title: '图片',
            iconSvg: '<svg viewBox="0 0 1024 1024"><path d="M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z"></path></svg>',
            menuKeys: ["insertImage", "uploadImage"]
          },
          "insertVideo",
          "insertTable",
          // "codeBlock",
          "|",
          "undo",
          "redo",
          "|",
          "fullScreen",
        ],
        // excludeKeys: [ /* 隐藏哪些菜单 */ ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        // autoFocus: false,
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          uploadImage: {
            async customUpload(file, insertFn) {
              const formData = new FormData()
              formData.append('file', file)
              authApi.uploadFile(formData).then(res => {
                insertFn(res.data)
              })
            }
          },
        },
      },
      mode: 'simple'
    };
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 【注意】一定要用 Object.seal() 否则会报错
    },
    onChange(editor) {
      let data = editor.getHtml() // onChange 时获取编辑器最新内容
      this.$emit("input", data);
      this.$emit("on-change", data);
      // console.log("onChange",editor.getHtml() ); // onChange 时获取编辑器最新内容
    },
    customInsertFn(res, insertFn) {
      if (res.success == true) {
        let url = res.result;
        insertFn(url);
        // this.$Message.success("上传视频成功");
      } else {
        this.$Message.error(res.message);
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.html = this.value
    }, 500)
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy()
  }
};
</script>
<style lang="less" scoped>
  .editor{
    border: 1px solid #ccc; margin-top: 10px;
    width: 90%;margin: 0 auto;
    .tool{
      border-bottom: 1px solid #ccc
    }
    .text{
      height: 400px; overflow-y: hidden
    }
  }
</style>
<style src="@wangeditor/editor/dist/css/style.css"></style>